import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./translations.json";
import { DEFAULT_LANGUAGE } from "./contexts/Language";

// Shared by src/index.js and scripts/prerender.js, which switch it to the
// page's language before rendering. The translations are bundled in, so
// init and changeLanguage take effect immediately.
i18n.use(initReactI18next).init({
  lng: DEFAULT_LANGUAGE,
  resources: translations,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
